
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { findLast, find } from 'lodash';
import { isBarVisualizer, isGlyphVisualizerOrSpaceOrBar, isSign } from './helpers';
import { GlyphVisualizer } from './GlyphVisualizer';
import { Custos } from '../signs';

export class VisualizerHelper {
  public static findLastGlyphOrSpaceOrBar(elements: ChantLayoutElement[]): ChantLayoutElement | undefined {
    return findLast(elements, (e) => isGlyphVisualizerOrSpaceOrBar(e));
  }

  public static findLastGlyphOrBar(elements: ChantLayoutElement[]): ChantLayoutElement | undefined {
    return findLast(elements, (e) => e instanceof GlyphVisualizer || isBarVisualizer(e));
  }

  public static findLastBar(elements: ChantLayoutElement[]): ChantLayoutElement | undefined {
    return findLast(elements, (e) => isBarVisualizer(e));
  }

  public static findLastGlyphOrSpaceOrBarOrSign(elements: ChantLayoutElement[]): ChantLayoutElement | undefined {
    return findLast(elements, (e) => isGlyphVisualizerOrSpaceOrBar(e) || isSign(e) || e instanceof Custos);
  }

  public static findLastGlyphVisualizer(elements: ChantLayoutElement[]): GlyphVisualizer | undefined {
    return findLast(elements, (e) => e instanceof GlyphVisualizer) as GlyphVisualizer;
  }

  public static findFirstGlyphVisualizer(elements: ChantLayoutElement[]): GlyphVisualizer | undefined {
    return find(elements, (e) => e instanceof GlyphVisualizer) as GlyphVisualizer;
  }
}
